/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { MilestoneDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All
 */
export const getMilestone = (signal?: AbortSignal) => {
  return customInstance<MilestoneDto[]>({
    url: `/milestone`,
    method: "GET",
    signal,
  });
};

export const getGetMilestoneInfiniteQueryKey = () => {
  return ["infinite", `/milestone`] as const;
};

export const getGetMilestoneQueryKey = () => {
  return [`/milestone`] as const;
};

export const getGetMilestoneInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestone>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMilestone>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMilestoneInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMilestone>>> = ({
    signal,
  }) => getMilestone(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMilestone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMilestoneInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMilestone>>
>;
export type GetMilestoneInfiniteQueryError = void;

export function useGetMilestoneInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestone>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestone>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestone>>,
          TError,
          Awaited<ReturnType<typeof getMilestone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestone>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestone>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestone>>,
          TError,
          Awaited<ReturnType<typeof getMilestone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestone>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetMilestoneInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestone>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMilestoneInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMilestoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getMilestone>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMilestone>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMilestoneQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMilestone>>> = ({
    signal,
  }) => getMilestone(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMilestone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMilestoneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMilestone>>
>;
export type GetMilestoneQueryError = void;

export function useGetMilestone<
  TData = Awaited<ReturnType<typeof getMilestone>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestone>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestone>>,
          TError,
          Awaited<ReturnType<typeof getMilestone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestone<
  TData = Awaited<ReturnType<typeof getMilestone>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestone>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestone>>,
          TError,
          Awaited<ReturnType<typeof getMilestone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestone<
  TData = Awaited<ReturnType<typeof getMilestone>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestone>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetMilestone<
  TData = Awaited<ReturnType<typeof getMilestone>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestone>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMilestoneQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postMilestone = (
  milestoneDto: MilestoneDto,
  signal?: AbortSignal,
) => {
  return customInstance<MilestoneDto>({
    url: `/milestone`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: milestoneDto,
    signal,
  });
};

export const getPostMilestoneMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMilestone>>,
    TError,
    { data: MilestoneDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMilestone>>,
  TError,
  { data: MilestoneDto },
  TContext
> => {
  const mutationKey = ["postMilestone"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMilestone>>,
    { data: MilestoneDto }
  > = (props) => {
    const { data } = props ?? {};

    return postMilestone(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMilestoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMilestone>>
>;
export type PostMilestoneMutationBody = MilestoneDto;
export type PostMilestoneMutationError = void;

/**
 * @summary Create
 */
export const usePostMilestone = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMilestone>>,
      TError,
      { data: MilestoneDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postMilestone>>,
  TError,
  { data: MilestoneDto },
  TContext
> => {
  const mutationOptions = getPostMilestoneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update
 */
export const putMilestoneId = (id: number, milestoneDto: MilestoneDto) => {
  return customInstance<MilestoneDto>({
    url: `/milestone/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: milestoneDto,
  });
};

export const getPutMilestoneIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMilestoneId>>,
    TError,
    { id: number; data: MilestoneDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMilestoneId>>,
  TError,
  { id: number; data: MilestoneDto },
  TContext
> => {
  const mutationKey = ["putMilestoneId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMilestoneId>>,
    { id: number; data: MilestoneDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putMilestoneId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMilestoneIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMilestoneId>>
>;
export type PutMilestoneIdMutationBody = MilestoneDto;
export type PutMilestoneIdMutationError = void;

/**
 * @summary Update
 */
export const usePutMilestoneId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMilestoneId>>,
      TError,
      { id: number; data: MilestoneDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putMilestoneId>>,
  TError,
  { id: number; data: MilestoneDto },
  TContext
> => {
  const mutationOptions = getPutMilestoneIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Id
 */
export const getMilestoneId = (id: number, signal?: AbortSignal) => {
  return customInstance<MilestoneDto>({
    url: `/milestone/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetMilestoneIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/milestone/${id}`] as const;
};

export const getGetMilestoneIdQueryKey = (id?: number) => {
  return [`/milestone/${id}`] as const;
};

export const getGetMilestoneIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMilestoneIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMilestoneId>>> = ({
    signal,
  }) => getMilestoneId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMilestoneId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMilestoneIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMilestoneId>>
>;
export type GetMilestoneIdInfiniteQueryError = void;

export function useGetMilestoneIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestoneId>>,
          TError,
          Awaited<ReturnType<typeof getMilestoneId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestoneId>>,
          TError,
          Awaited<ReturnType<typeof getMilestoneId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetMilestoneIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMilestoneIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMilestoneIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMilestoneId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestoneId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMilestoneIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMilestoneId>>> = ({
    signal,
  }) => getMilestoneId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMilestoneId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMilestoneIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMilestoneId>>
>;
export type GetMilestoneIdQueryError = void;

export function useGetMilestoneId<
  TData = Awaited<ReturnType<typeof getMilestoneId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestoneId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestoneId>>,
          TError,
          Awaited<ReturnType<typeof getMilestoneId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneId<
  TData = Awaited<ReturnType<typeof getMilestoneId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestoneId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestoneId>>,
          TError,
          Awaited<ReturnType<typeof getMilestoneId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneId<
  TData = Awaited<ReturnType<typeof getMilestoneId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestoneId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetMilestoneId<
  TData = Awaited<ReturnType<typeof getMilestoneId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMilestoneId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMilestoneIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteMilestoneId = (id: number) => {
  return customInstance<boolean>({ url: `/milestone/${id}`, method: "DELETE" });
};

export const getDeleteMilestoneIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMilestoneId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMilestoneId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMilestoneId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMilestoneId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMilestoneId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMilestoneIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMilestoneId>>
>;

export type DeleteMilestoneIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteMilestoneId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMilestoneId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMilestoneId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteMilestoneIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All By Phase Id
 */
export const getMilestoneIdPhase = (id: number, signal?: AbortSignal) => {
  return customInstance<MilestoneDto[]>({
    url: `/milestone/${id}/phase`,
    method: "GET",
    signal,
  });
};

export const getGetMilestoneIdPhaseInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/milestone/${id}/phase`] as const;
};

export const getGetMilestoneIdPhaseQueryKey = (id?: number) => {
  return [`/milestone/${id}/phase`] as const;
};

export const getGetMilestoneIdPhaseInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMilestoneIdPhaseInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMilestoneIdPhase>>
  > = ({ signal }) => getMilestoneIdPhase(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMilestoneIdPhase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMilestoneIdPhaseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMilestoneIdPhase>>
>;
export type GetMilestoneIdPhaseInfiniteQueryError = void;

export function useGetMilestoneIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneIdPhase>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestoneIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getMilestoneIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestoneIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getMilestoneIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Phase Id
 */

export function useGetMilestoneIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMilestoneIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMilestoneIdPhaseInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMilestoneIdPhaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMilestoneIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMilestoneIdPhaseQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMilestoneIdPhase>>
  > = ({ signal }) => getMilestoneIdPhase(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMilestoneIdPhase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMilestoneIdPhaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMilestoneIdPhase>>
>;
export type GetMilestoneIdPhaseQueryError = void;

export function useGetMilestoneIdPhase<
  TData = Awaited<ReturnType<typeof getMilestoneIdPhase>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestoneIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getMilestoneIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneIdPhase<
  TData = Awaited<ReturnType<typeof getMilestoneIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMilestoneIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getMilestoneIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMilestoneIdPhase<
  TData = Awaited<ReturnType<typeof getMilestoneIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Phase Id
 */

export function useGetMilestoneIdPhase<
  TData = Awaited<ReturnType<typeof getMilestoneIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMilestoneIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMilestoneIdPhaseQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
